"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsButton = exports.CommonControlsText = exports.Dialog = exports.ApplicationWorkflowIsolationBar = exports.ApplicationTitleHeader = exports.LayoutControlsPanel = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.ApplicationWorkflowTemplate = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var ApplicationTitleHeader_1 = require("../ApplicationTitleHeader/ApplicationTitleHeader");
Object.defineProperty(exports, "ApplicationTitleHeader", { enumerable: true, get: function () { return ApplicationTitleHeader_1.ApplicationTitleHeader; } });
var ApplicationWorkflowIsolationBar_1 = require("../ApplicationWorkflowIsolationBar/ApplicationWorkflowIsolationBar");
Object.defineProperty(exports, "ApplicationWorkflowIsolationBar", { enumerable: true, get: function () { return ApplicationWorkflowIsolationBar_1.ApplicationWorkflowIsolationBar; } });
var Dialog_1 = require("../Dialog/Dialog");
Object.defineProperty(exports, "Dialog", { enumerable: true, get: function () { return Dialog_1.Dialog; } });
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var Button_1 = require("player-common-controls/controls/Button");
Object.defineProperty(exports, "CommonControlsButton", { enumerable: true, get: function () { return Button_1.Button; } });
var ApplicationWorkflowTemplate = (function (_super) {
    __extends(ApplicationWorkflowTemplate, _super);
    function ApplicationWorkflowTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowTemplate.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowTemplate.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowTemplate.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowTemplate.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowTemplate.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowTemplate.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowTemplate.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowTemplate.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowTemplate.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(GridLayout_1.GridLayout, { key: 0, colsWidth: "12", colsWidthForSm: "10", colsWidthForXl: "8", children: [React.createElement(GridCol_1.GridCol, { key: 0, offsetLeftForSm: "1", offsetLeftForXl: "2", children: [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: $this.state.viewModel.contentPaddingBottom, children: [React.createElement(ApplicationTitleHeader_1.ApplicationTitleHeader, { key: 0, currentPage: $this.state.viewModel.currentPage, totalPages: $this.state.viewModel.totalPages, imgUrl: $this.state.viewModel.headerImgUrl, title: $this.state.viewModel.title, titlePadding: $this.state.viewModel.titlePadding, SPStepText: $this.state.viewModel.SPStepText }), React.createElement(Panel_1.Panel, { key: 1, backgroundColor: "White", borderColorAll: "Grey40", borderStyleAll: "Solid", borderWidthAll: $this.state.viewModel.borderWidth, roundedCorner: "All", paddingAll: $this.state.viewModel.paddingSize, children: [React.createElement(Panel_1.Panel, { key: 0, paddingAll: $this.state.viewModel.paddingSizeTwo, children: [_this.props.children] })] })] })] }), React.createElement(GridCol_1.GridCol, { key: 1, offsetLeftForSm: "1", offsetLeftForXl: "2", isVisible: !$this.state.viewModel.hideIsolationBar, children: [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Xlarge", children: [React.createElement(ApplicationWorkflowIsolationBar_1.ApplicationWorkflowIsolationBar, { key: 0, currentPage: $this.state.viewModel.currentPage, totalPages: $this.state.viewModel.totalPages, backBtnText: $this.state.viewModel.IBbackBtnText, cancelBtnText: $this.state.viewModel.IBcancelBtnText, nextBtnText: $this.state.viewModel.IBnextBtnText, saveBtnText: $this.state.viewModel.IBsaveBtnText, submitBtnText: $this.state.viewModel.IBsubmitBtnText, submitBtnDisabled: $this.state.viewModel.submitBtnDisabled, onNext: _this._proxyEvent("onNext"), onBack: _this._proxyEvent("onBack"), onSubmit: _this._proxyEvent("onSubmit"), onCancel: _this._proxyEvent("onCancel"), onSave: _this._proxyEvent("onSave") })] })] })] }), React.createElement(Dialog_1.Dialog, { key: 1, isVisible: $this.state.viewModel.isLoginDialogVisible, id: "saveLoginDialog", tag: "saveLoginDialog", title: $this.state.viewModel.DialogTitleText, usePortal: true, children: [React.createElement(Panel_1.Panel, { key: 0, horizontalAlign: "Center", children: [React.createElement(Text_1.Text, { key: 0, color: "Muted", mode: "Paragraph", size: "Large", tag: "loginDialogText", text: $this.state.viewModel.DialogText })] })], footer: [React.createElement(Panel_1.Panel, { key: 0, width: "100%", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Small", gutterVertical: "Xsmall", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "Fill", children: [] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "Auto", children: [React.createElement(Button_1.Button, { key: 0, color: "Grey", tag: "saveDialogCancelBtn", text: $this.state.viewModel.CancelText, width: "Block", onClick: _this._proxyEvent("onLoginDialogClose") })] }), React.createElement(GridCol_1.GridCol, { key: 2, width: "Auto", children: [React.createElement(Button_1.Button, { key: 0, color: "Primary", tag: "saveDialogLoginBtn", text: $this.state.viewModel.SignInButtonText, width: "Block", onClick: _this._proxyEvent("onSignInClick") })] })] })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkflowtemplate" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowTemplate.defaultProps = {
        currentPage: "", totalPages: "", headerImgUrl: "", title: "", paddingSize: "", paddingSizeTwo: "", borderWidth: "", titlePadding: "", DialogTitleText: "", DialogText: "", SignInButtonText: "", CancelText: "", IBcancelBtnText: "", IBbackBtnText: "", IBnextBtnText: "", IBsubmitBtnText: "", IBsaveBtnText: "", SPStepText: "", submitBtnDisabled: "",
        onNext: function () { }, onBack: function () { }, onSubmit: function () { }, onCancel: function () { }, onSave: function () { },
        children: []
    };
    return ApplicationWorkflowTemplate;
}(React.Component));
exports.ApplicationWorkflowTemplate = ApplicationWorkflowTemplate;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowTemplate"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowTemplate/ApplicationWorkflowTemplate.js
// module id = 596
// module chunks = 0